import { render, staticRenderFns } from "./widget_platinium_best_values.vue?vue&type=template&id=607ff292&scoped=true&"
import script from "./widget_platinium_best_values.vue?vue&type=script&lang=js&"
export * from "./widget_platinium_best_values.vue?vue&type=script&lang=js&"
import style0 from "./widget_platinium_best_values.vue?vue&type=style&index=0&id=607ff292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ff292",
  null
  
)

export default component.exports